exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout-header-header-4kOsu{display:flex;align-items:center;justify-content:space-between;width:100%;height:56px}.layout-header-icon-button-1TLyF{background:none;border:none;cursor:pointer;width:24px;height:24px;margin:16px;border-radius:50%}.layout-header-icon-button-1TLyF:hover{background-color:#f0f0f0}.layout-header-title-1cud7{flex-grow:1;text-align:center;font-size:17px;font-weight:700;margin:0}", ""]);

// Exports
exports.locals = {
	"header": "layout-header-header-4kOsu",
	"icon-button": "layout-header-icon-button-1TLyF",
	"title": "layout-header-title-1cud7"
};